var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/contact"}},[_c('base-button',{staticClass:"badge-pill border-0 text-white px-sm connect-gradient"},[_vm._v("Contact")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }